module.exports = __webpack_public_path__ + "img/CommonStatistics.e5925afa.svg";